import { ButtonPrimary, ButtonSize, IconLoader } from '@ui/src';
import AuthorizationForm from '../../../components/settings/details-form/authorization-form';
import useAuthorization from './hooks/use-authorization';

import cn from '../styles.module.css';

const PspAuthorization = () => {
  const {
    isLoading,
    errorList,
    control,
    onSubmit,
    globalError,
    editIsLoading,
    isDirty,
  } = useAuthorization();

  let content;

  if (isLoading) {
    content = (
      <div className={cn.settingsLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        {!errorList && (
          <AuthorizationForm control={control} onSubmit={onSubmit}>
            <>
              {globalError && (
                <div className={cn.saveGlobalError}>{globalError}</div>
              )}
              <ButtonPrimary
                text={editIsLoading ? 'Loading...' : 'Save'}
                onClick={onSubmit}
                bold
                size={ButtonSize.MEDIUM}
                disabled={editIsLoading || !isDirty}
                className={cn.saveDetailsButton}
              />
            </>
          </AuthorizationForm>
        )}
        {errorList && (
          <div className={cn.loadingError}>
            <div className={cn.loadingErrorTitle}>Unable to load data</div>
            <div className={cn.loadingErrorText}>{errorList}</div>
          </div>
        )}
      </>
    );
  }

  return content;
};

export default PspAuthorization;
